import * as React from 'react';
import loc from 'owa-localize';
import { roomBookingAssistant } from './RoomBookingAssistant.locstring.json';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { ActionButton, IButtonStyles } from '@fluentui/react/lib/Button';

import styles from './FullComposeLeftPane.scss';

export interface RoomBookingAssistantButtonProps {
    buttonStyle?: IButtonStyles;
    onClick?: () => void;
}

const RoomBookingAssistantButton = (props: RoomBookingAssistantButtonProps) => {
    const { buttonStyle, onClick } = props;

    return (
        <TooltipHost
            content={loc(roomBookingAssistant)}
            hostClassName={styles.roomBookingAssistantButtonToolTip}
            id="roomBookingAssistantButton">
            <ActionButton
                className={styles.roomBookingAssistantButton}
                styles={buttonStyle}
                onClick={onClick}
                aria-labelledby={'roomBookingAssistantButton'}>
                {loc(roomBookingAssistant)}
            </ActionButton>
        </TooltipHost>
    );
};

export default RoomBookingAssistantButton;
